import { RSAA } from 'redux-api-middleware';

export const SPLITS_IS_FETCHING = 'SPLITS_IS_FETCHING';
export const SPLITS_GET_SUCCESS = 'SPLITS_GET_SUCCESS';
export const SPLITS_GET_ERROR = 'SPLITS_GET_ERROR';

// Initial State
export const initialState = {
  defaultSearchParams: {
    perPage: 100,
    page: 1
  },
  isFetching: false,
  items: [],
  error: null
};

// Actions
export const getSplitsList = queryString => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_SPLIT',
      controlAction: 'collection',
      queryString,
      types: [
        SPLITS_IS_FETCHING,
        {
          type: SPLITS_GET_SUCCESS,
          meta: { ...queryString }
        },
        SPLITS_GET_ERROR
      ]
    }
  };
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case SPLITS_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case SPLITS_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        items: action.payload.items.reduce((map, item) => {
          map[item.name] = item.enabled;
          return map;
        }, {})
      };

    case SPLITS_GET_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};
